import { render, staticRenderFns } from "./judges_cider_table.vue?vue&type=template&id=8ba90ac0&scoped=true"
import script from "./judges_cider_table.vue?vue&type=script&lang=js"
export * from "./judges_cider_table.vue?vue&type=script&lang=js"
import style0 from "./judges_cider_table.vue?vue&type=style&index=0&id=8ba90ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba90ac0",
  null
  
)

export default component.exports